import { useState } from 'react';

// Compact multi-select for badges/pass levels. Most people hold ONE badge, but
// some (Mel Davis: Media + Kids) need several — values store comma-joined in
// the same passLevel field, so nothing downstream changes shape.
export default function PassLevelMultiSelect({ value, options = [], onChange, disabled }) {
  const [open, setOpen] = useState(false);
  // Near the bottom of the screen the menu flips upward so the last rows of a
  // roster can still reach every option (downward it clips at the panel edge).
  const [openUp, setOpenUp] = useState(false);
  const selected = String(value || '').split(',').map(s => s.trim()).filter(Boolean);
  // Keep any already-assigned value visible even if it's not in the configured list.
  const allOptions = Array.from(new Set([...selected, ...options])).filter(Boolean);
  const label = selected.length === 0
    ? '—'
    : selected.length === 1
      ? selected[0]
      : `${selected[0]} +${selected.length - 1}`;

  const toggle = (opt) => {
    const next = selected.includes(opt)
      ? selected.filter(s => s !== opt)
      : [...selected, opt];
    onChange(next.join(', '));
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }} onClick={e => e.stopPropagation()}>
      <button
        className="pass-select"
        style={{ cursor: disabled ? 'default' : 'pointer', textAlign: 'left', whiteSpace: 'nowrap' }}
        onClick={(e) => {
          if (disabled) return;
          const rect = e.currentTarget.getBoundingClientRect();
          setOpenUp(window.innerHeight - rect.bottom < 280);
          setOpen(o => !o);
        }}
        title={selected.length > 1 ? selected.join(', ') : 'Select badge(s)'}
      >
        {label} ▾
      </button>
      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 60 }} onClick={() => setOpen(false)} />
          <div style={{ position: 'absolute', ...(openUp ? { bottom: '100%', marginBottom: 4 } : { top: '100%', marginTop: 4 }), left: 0, zIndex: 61, minWidth: 170, background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', boxShadow: '0 8px 24px rgba(0,0,0,0.13)', maxHeight: 240, overflowY: 'auto' }}>
            {allOptions.length === 0 && (
              <div style={{ padding: '9px 12px', fontFamily: 'var(--font-b)', fontSize: 12, color: 'var(--muted)' }}>No pass levels configured.</div>
            )}
            {allOptions.map(opt => (
              <label
                key={opt}
                style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border)', background: selected.includes(opt) ? 'var(--off)' : 'var(--white)' }}
              >
                <input
                  type="checkbox"
                  checked={selected.includes(opt)}
                  onChange={() => toggle(opt)}
                  style={{ accentColor: 'var(--black)', flexShrink: 0 }}
                />
                <span style={{ fontFamily: 'var(--font-b)', fontSize: 13 }}>{opt}</span>
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
